/**
 * @file
 * JavaScript behaviors for PDF Embedded component.
 */

(function (Drupal, once) {
  'use strict';

  /**
   * Behavior for PDF embedded component.
   */
  Drupal.behaviors.pdfEmbedded = {
    attach: function (context) {
      const containers = once('pdf-embedded', '.pdf-embedded', context);

      containers.forEach(container => {
        // Handle PDF fallback detection
        const pdfContainer = container.querySelector('[data-pdf-container]');
        if (pdfContainer) {
          const iframe = pdfContainer.querySelector('iframe[data-pdf-viewer]');
          const fallback = pdfContainer.querySelector('[data-pdf-fallback]');

          if (iframe && fallback) {
            // Try to detect if PDF fails to load
            iframe.addEventListener('error', () => {
              fallback.style.display = 'flex';
              iframe.style.display = 'none';
            });

            // Fallback timeout in case error event doesn't fire
            setTimeout(() => {
              try {
                // If iframe hasn't loaded properly, show fallback
                if (!iframe.contentWindow || !iframe.contentWindow.document) {
                  fallback.style.display = 'flex';
                  iframe.style.display = 'none';
                }
              } catch (e) {
                // Cross-origin restrictions may prevent access
                // In this case, assume PDF is loading correctly
              }
            }, 3000);
          }
        }
      });
    }
  };

})(Drupal, once);
